

const energyData = [
  { name: "Choisir une énergie", id: "choice" },
  { name: "Electricité", id: "electricity" },
  { name: "Gaz", id: "gas" },
  { name: "Eau", id: "water" },
  { name: "Chaleur", id: "heat" },
  { name: "Froid", id: "cold" },
  { name: "Propane", id: "propane" },
  { name: "Fioul", id: "fuel" },
  { name: "Bois", id: "wood" },
];

const energy2Data = [
  { name: "Electricité", id: "electricity" },
  { name: "Gaz", id: "gas" },
  { name: "Eau", id: "water" },
  { name: "Chaleur", id: "heat" },
  { name: "Froid", id: "cold" },
  { name: "Propane", id: "propane" },
  { name: "Fioul", id: "fuel" },
  { name: "Bois", id: "wood" },
];

const consoUnitData = [
  { name: "kWh", id: "electricity" },
  { name: "kWh", id: "gas" },
  { name: "m3", id: "water" },
  { name: "MWh", id: "heat" },
  { name: "MWh", id: "cold" },
  { name: "kg", id: "propane" },
  { name: "L", id: "fuel" },
  { name: "", id: "wood" },
];




const listcontainscomparator = [
  {
    id: "containsone",
    name: "Contient",
  }
];

const datedistributionData = [
  { name: "A la date de fin de relève", id: "dateend" },
  { name: "A la date d'émission du document", id: "billdate" },
  { name: "Réparti entre la date de début et de fin de relève", id: "distributed" },
]

const isisnotcomparator = [
  {
    id: "is",
    name: "Est",
  },
  {
    id: "isnot",
    name: "N'est pas",
  }
]

const textcomparator = [
  {
    id: "equals",
    name: "Est",
  },
  {
    id: "beginswith",
    name: "Commence par",
  },
  {
    id: "endswith",
    name: "Fini par",
  },
  {
    id: "contains",
    name: "Contient",
  },
  {
    id: "notcontains",
    name: "Ne contient pas",
  }
]

const datecomparator = [
  {
    id: "equals",
    name: "Est le",
  },
  {
    id: "before",
    name: "Est avant le",
  },
  {
    id: "after",
    name: "Est après le",
  }
]

const numbercomparator = [
  {
    id: "equals",
    name: "=",
  },
  {
    id: "lower",
    name: "<",
  },
  {
    id: "lowerequals",
    name: "<=",
  },
  {
    id: "greater",
    name: ">",
  },
  {
    id: "greaterequals",
    name: ">=",
  }
]

const listcountcomparator = [
  {
    id: "equals",
    name: "=",
  },
  {
    id: "lower",
    name: "<",
  },
  {
    id: "lowerequals",
    name: "<=",
  },
  {
    id: "greater",
    name: ">",
  },
  {
    id: "greaterequals",
    name: ">=",
  }
]

export const authorizationstatusData = [
  { name: "Valide", id: 1, color: "#91C73C" },
  { name: "Supprimée", id: -1, color: "#C53F3F" },
  { name: "Aucune autorisation", id: -2, color: "#C53F3F" },
  { name: "Non vérifiée", id: -3, color: "#C53F3F" },
  { name: "Refusée", id: -4, color: "#C53F3F" },
  { name: "Pas encore valide", id: -5, color: "#C53F3F" },
  { name: "Périmée", id: -6, color: "#C53F3F" },
]

const statusData = [
  { name: "Actif", id: "on", color: "#91C73C" },
  { name: "Inactif", id: "off", color: "#C53F3F" },
];

const filterstatusData = [
  { name: "Active", id: "active", color: "#91C73C" },
  { name: "Inactive", id: "inactive", color: "#C53F3F" },
  { name: "En erreur", id: "error", color: "#C53F3F" },
];

const filtersData = [
  {
    id: "meternumber",
    name: "N° de compteur",
    comparator: textcomparator,
    datatype: "text",
  },
  {
    id: "status",
    name: "Statut",
    comparator: isisnotcomparator,
    datatype: "select",
    data: statusData
  },
  {
    id: "segment",
    name: "Segment",
    comparator: textcomparator,
    datatype: "text",
  },
  {
    id: "authorizationstatus",
    name: "Autorisation distributeur",
    comparator: isisnotcomparator,
    datatype: "select",
    data: authorizationstatusData,
  },
  {
    id: "monthlydatastatus",
    name: "Etat de la relève",
    comparator: isisnotcomparator,
    datatype: "select",
    data : filterstatusData,
  },
  {
    id: "lastmonthlyconsumption",
    name: "Date de la dernière relève",
    comparator: datecomparator,
    datatype: "date",
  },
  {
    id: "loadcurvestatus",
    name: "Etat courbe de charge",
    comparator: isisnotcomparator,
    datatype: "select",
    data : filterstatusData,
  },
]

const displaymethodData = [
  {
    id: "docreference",
    name: "Grouper par numéro de document",
  },
  {
    id: "pdl",
    name: "Grouper par numéro de PDL",
  }
]

const divisionUnitData = [
  { name: "%", id: "percent" },
  { name: "m²", id: "sqrmtr" },
  { name: "autre", id: "other" },
];




const datachoiceData = [
  { name: "Courbe de charge", id: "load_520", unit: "kW", energy: "electricity", segment: ["P1", "C1", "C2", "C3", "C4", "C5"] },
  { name: "Courbe de production", id: "load_1461", unit: "kW", energy: "electricity", segment: ["P1", "P2", "P3", "P4"] },
  // { name: "Puissances max atteintes", id: "load_1403", unit: "kW", energy: "electricity", segment: ["C5"] },
  // { name: "Puissances max atteintes HPE", id: "load_1396", unit: "kW", energy: "electricity", segment: ["C1", "C2", "C3", "C4"] },
  // { name: "Puissances max atteintes HCE", id: "load_1397", unit: "kW", energy: "electricity", segment: ["C1", "C2", "C3", "C4"] },
  // { name: "Puissances max atteintes HPH", id: "load_1398", unit: "kW", energy: "electricity", segment: ["C1", "C2", "C3", "C4"] },
  // { name: "Puissances max atteintes HCH", id: "load_1399", unit: "kW", energy: "electricity", segment: ["C1", "C2", "C3", "C4"] },
  // { name: "Puissances max atteintes Pointe", id: "load_1400", unit: "kW", energy: "electricity", segment: ["C1", "C2", "C3", "C4"] },
  { name: "Consommation Base", id: "bill_1198", unit: "kWh", energy: "electricity", segment: ["C5"] },
  { name: "Consommation HP", id: "bill_1199", unit: "kWh", energy: "electricity", segment: ["C5"] },
  { name: "Consommation HC", id: "bill_1200", unit: "kWh", energy: "electricity", segment: ["C5"] },
  { name: "Consommation HPE", id: "bill_1201", unit: "kWh", energy: "electricity", segment: ["P1", "C1", "C2", "C3", "C4", "C5"] },
  { name: "Consommation HCE", id: "bill_1202", unit: "kWh", energy: "electricity", segment: ["P1", "C1", "C2", "C3", "C4", "C5"] },
  { name: "Consommation HPH", id: "bill_1203", unit: "kWh", energy: "electricity", segment: ["P1", "C1", "C2", "C3", "C4", "C5"] },
  { name: "Consommation HCH", id: "bill_1204", unit: "kWh", energy: "electricity", segment: ["P1", "C1", "C2", "C3", "C4", "C5"] },
  { name: "Consommation Pointe", id: "bill_1205", unit: "kWh", energy: "electricity", segment: ["P1", "C1", "C2", "C3", "C4", "C5"] },
  { name: "Somme des consommations relevées", id: "bill_1198_1199_1200_1201_1202_1203_1204_1205", unit: "kWh", energy: "electricity", segment: ["P1", "C1", "C2", "C3", "C4", "C5"] },
  { name: "Index quotidien HPE", id: "load_1388", unit: "kWh", energy: "electricity", segment: ["P1", "C1", "C2", "C3", "C4"] },
  { name: "Index quotidien HCE", id: "load_1389", unit: "kWh", energy: "electricity", segment: ["P1", "C1", "C2", "C3", "C4"] },
  { name: "Index quotidien HPH", id: "load_1390", unit: "kWh", energy: "electricity", segment: ["P1", "C1", "C2", "C3", "C4"] },
  { name: "Index quotidien HCH", id: "load_1391", unit: "kWh", energy: "electricity", segment: ["P1", "C1", "C2", "C3", "C4"] },
  { name: "Index quotidien Pointe", id: "load_1392", unit: "kWh", energy: "electricity", segment: ["P1", "C1", "C2", "C3", "C4"] },
  { name: "Index quotidien Base", id: "load_1385", unit: "kWh", energy: "electricity", segment: ["C5"] },
  { name: "Index quotidien HP", id: "load_1386", unit: "kWh", energy: "electricity", segment: ["C5"] },
  { name: "Index quotidien HC", id: "load_1387", unit: "kWh", energy: "electricity", segment: ["C5"] },
  { name: "Somme des index quotidiens", id: "load_1385_1386_1387_1388_1389_1390_1391_1392", unit: "kWh", energy: "electricity", segment: ["P1", "C1", "C2", "C3", "C4", "C5"] },
  { name: "Consommation journalière", id: "load_1315", unit: "kWh", energy: "gas" },
  { name: "Consommation relevée", id: "bill_1269", unit: "kWh", energy: "gas" },
];

export const methodData = {
  rawload:
    [
      { name: "Afficher les données brutes", id: "raw" },
    ],
  rawbill:
    [
      { name: "Afficher les données brutes", id: "raw" },
    ],
  siteload:
    [
      { name: "Afficher les données 10 minutes", id: "10m" },
      { name: "Afficher les données aggrégées horaires", id: "1h" },
      { name: "Afficher les données aggrégées journalières", id: "1d" },
    ],
  sitebill:
    [
      { name: "Afficher les données brutes", id: "raw" },
      { name: "Afficher les données aggrégées", id: "1M" },
    ]
}

export const dashboardTypeData = {
  electricity:
    [
      { name: "Consommation relevée", id: "monthly" },
      { name: "Courbe de charge", id: "load" },
      { name: "Courbe de production", id: "prod" },
    ],
  gas:
    [
      { name: "Consommation relevée", id: "monthly" },
      { name: "Consommation journalière", id: "load" },
    ],
  water:
    [
      { name: "Consommation relevée", id: "monthly" }
    ],
  heat:
    [
      { name: "Consommation relevée", id: "monthly" }
    ],
  cold:
    [
      { name: "Consommation relevée", id: "monthly" }
    ],
  propane:
    [
      { name: "Consommation relevée", id: "monthly" }
    ],
  fuel:
    [
      { name: "Consommation relevée", id: "monthly" }
    ],
  wood:
    [
      { name: "Consommation relevée", id: "monthly" }
    ],
}

export const historicalData = {
  electricity:
    [
      { name: "Courbe de charge", id: "load" },
      { name: "Consommation relevée", id: "monthly" }
    ],
  gas:
    [
      { name: "Consommation journalière", id: "load" },
      { name: "Consommation relevée", id: "monthly" }
    ]
}

export const methodDataRaw = [
  { name: "Afficher les données brutes", id: "raw" },
]

export const methodDataRessend = [
  { name: "Depuis les données brutes", id: "raw" },
  { name: "Depuis les données aggrégées", id: "agg" },
]

export const historicalrequeststatusData = [
  { name: "Demande prise en compte", id: 1 },
  { name: "Historique récupéré", id: 2 },
  { name: "Erreur dans la récupération", id: 3 },
  { name: "Aucune requête", id: 0 },
]

export const displayData = [
  { name: "Tableau", id: "tab" },
  { name: "Courbe", id: "linechart" },
  { name: "Histogramme", id: "barchart" },
]

export const displayDataonehour = [
  { name: "Afficher les données en tableau", id: "tab" },
  { name: "Afficher les données en courbe", id: "linechart" },
  { name: "Afficher les données en histogramme", id: "barchart" },
  { name: "Afficher les données en heatmap", id: "heatmap" },
]

export const monthnameData = [
  { name: "Janvier", id: "January" },
  { name: "Février", id: "February" },
  { name: "Mars", id: "March" },
  { name: "Avril", id: "April" },
  { name: "Mai", id: "May" },
  { name: "Juin", id: "June" },
  { name: "Juillet", id: "July" },
  { name: "Août", id: "August" },
  { name: "Septembre", id: "September" },
  { name: "Octobre", id: "October" },
  { name: "Novembre", id: "November" },
  { name: "Décembre", id: "December" },
  { name: "Janvier", id: "janvier" },
  { name: "Février", id: "février" },
  { name: "Mars", id: "mars" },
  { name: "Avril", id: "avril" },
  { name: "Mai", id: "mai" },
  { name: "Juin", id: "juin" },
  { name: "Juillet", id: "juillet" },
  { name: "Août", id: "août" },
  { name: "Septembre", id: "septembre" },
  { name: "Octobre", id: "octobre" },
  { name: "Novembre", id: "novembre" },
  { name: "Décembre", id: "décembre" },
]

export {energy2Data, energyData, consoUnitData, filtersData, displaymethodData, divisionUnitData, statusData, datachoiceData, datedistributionData };
